import { Grid, GridCol } from '@naf/grid';
import { breakpoints, spacing } from '@naf/theme';
import styled from '@emotion/styled';
import { isNotTransientProp } from '../../lib/shouldForwardProp';

export const FeatureHeaderWrapper = styled.div`
  margin: 0 -${spacing.space80};

  @media (max-width: ${breakpoints.xl}) {
    margin: 0;
  }

  @media (max-width: ${breakpoints.m}) {
    margin: 0 -${spacing.space24};
  }
`;

// Breadcrumb sits above the hero image in dark text (matches legacy
// FeatureHeader); the negative top margin tucks it up toward the navbar.
export const BreadcrumbWrapper = styled.div`
  margin: -${spacing.space56} auto ${spacing.space40} auto;
  z-index: 10;
  display: flex;

  @media (max-width: ${breakpoints.l}) {
    margin: -${spacing.space32} auto ${spacing.space16} ${spacing.space16};
  }

  @media (max-width: ${breakpoints.m}) {
    margin: -${spacing.space8} auto ${spacing.space8} ${spacing.space16};
  }
`;

export const HeaderContentGridCol = styled(GridCol)`
  grid-column: 3 / -3;

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;

export const HeaderWrapperContentGrid = styled(Grid, { shouldForwardProp: isNotTransientProp })<{
  $hasIngress: boolean;
}>`
  margin-bottom: ${(props: { $hasIngress: boolean }) => (props.$hasIngress ? spacing.space48 : 0)};
  grid-row-gap: 0;

  @media (max-width: ${breakpoints.m}) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;
